module.exports = __webpack_public_path__ + "img/calendar-1733-pagina-de-titlu-big.cefc590a.jpg";